import { Badge } from "react-bootstrap"
import { isBusinessLocked } from "../../../utils/isBusinessLocked"
import { useMemo } from "react";

const WorkspaceLockLabel = ({organization, className}) => {
    const isBusinessLockedMemoized = useMemo(() => isBusinessLocked(organization), [organization]);

    console.log(organization)

    if(!isBusinessLockedMemoized) {
        return null;
    }

    return (
        <Badge bg={'dark-gray'} className="py-2 px-12px">Locked</Badge>
    )
}

export default WorkspaceLockLabel